<template>
    <div>
        <InfoPageBlock
            h1="Let’s get your trademark back on path."
            stepsLength="9"
            url="/trademark-office-action/confirm"
        ></InfoPageBlock>
    </div>
</template>

<script>
import InfoPageBlock from '@/components/blocks/InfoPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        InfoPageBlock
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>
